import * as React from 'react';
import { ArticleHeading1, Responsive, UIHeading2 } from '@cian/ui-kit';

export const AboutTitle = () => {
  return (
    <>
      <Responsive desktop>
        <ArticleHeading1>О застройщике</ArticleHeading1>
      </Responsive>
      <Responsive phone tablet>
        <UIHeading2>О застройщике</UIHeading2>
      </Responsive>
    </>
  );
};
